import * as React from 'react';

import { makeGridPopupContainer } from '../../containers/GridPopup/GridPopup';
import { Bem } from '../../service/Bem/Bem';
import { BasePopupProps } from '../../typings/common';
import { PopupDecorator } from '../PopupDecorator/PopupDecorator';

import './GridESSStatusCellJSON.css';

type GridESSStatusCellJSONProps = {
    aggregatedStatus: string | null;
};

const BLOCK = 'grid-ess-status-cell-json';

class GridESSStatusCellJSON extends React.PureComponent<GridESSStatusCellJSONProps & BasePopupProps> {
    private popupAnchor = React.createRef<HTMLDivElement>();

    render() {
        const { aggregatedStatus, openPopup } = this.props;

        return (
            <div
                className={Bem.cls(BLOCK)}
                ref={this.popupAnchor}
                onClick={aggregatedStatus !== null ? openPopup : undefined}
            >
                {aggregatedStatus}
                {aggregatedStatus !== null && this.getPopup()}
            </div>
        );
    }

    private getPopup = () => {
        const { isPopupVisible, closePopup, aggregatedStatus } = this.props;

        return (
            <PopupDecorator
                cls={Bem.cls(BLOCK, 'popup')}
                onClose={closePopup}
                target={'anchor'}
                anchor={this.popupAnchor.current}
                directions={['right-center', 'right-top', 'right-bottom', 'left-center']}
                visible={isPopupVisible}
                hasTail={true}
                onOutsideClick={closePopup}
            >
                <div className={Bem.cls(BLOCK, 'popup-content')}>{aggregatedStatus}</div>
            </PopupDecorator>
        );
    };
}

export const GridESSStatusCellJSONContainer = makeGridPopupContainer<GridESSStatusCellJSONProps>(GridESSStatusCellJSON);
